/***************************** overwrites theme js | Latori Software www.latori.com *****************************/
(() => {
  function init() {
    var swiper = null;

    var initMobileSlider = function() {
      var screenWidth = $(document).width();
      if (screenWidth <= 769) {
        if (swiper == null) {
          swiper = new Swiper('.swiper_active .swiper-container:not(.js-product-card-slider)', {
            initialSlide: 1,
            pagination: {
              el: '.swiper-pagination'
            }
          });
        }
      }
    };

    initMobileSlider();

    $(window).resize(function() {
      var screenWidth = $(document).width();
      if (screenWidth <= 769) {
        initMobileSlider();
      } else {
        if (swiper && swiper.destroy) {
          swiper.destroy();
          swiper = null;
          setTimeout(function() {
            $('.swiper-container .swiper-slide, .swiper-wrapper').attr('style', '');
          }, 1);
        }
      }
    });

    var initProductCardSlider = function() {
      document.querySelectorAll('.js-product-card-slider').forEach(container => {
        new Swiper($(container), {
          initialSlide: 0,
          slidesPerView: 1,
          observer: true,
          observeParents: true,
          spaceBetween: 5,
          breakpoints: {
            // when window width is <= 640px
            769: {
              watchOverflow: true,
              slidesPerView: 3,
              spaceBetween: 12
            },
            1200: {
              watchOverflow: true,
              slidesPerView: 4,
              spaceBetween: 32
            }
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        });
      });
    };

    initProductCardSlider();

    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') ==
            this.pathname.replace(/^\//, '') &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate(
              {
                scrollTop: target.offset().top
              },
              1000,
              function() {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(':focus')) {
                  // Checking if the target was focused
                  return false;
                } else {
                  $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                }
              }
            );
          }
        }
      });
  };

  window.addEventListener('load', init);
})();
